import { render, staticRenderFns } from "./userGrade.vue?vue&type=template&id=2c1e4bc8&scoped=true&"
import script from "./userGrade.vue?vue&type=script&lang=js&"
export * from "./userGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e4bc8",
  null
  
)

export default component.exports